import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';
import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title, Span } from '../../components/Shared/TitleSuccess';

import { setExitingCardProps, getExitingCardProps } from '../Widget/actions';

import { ActionTypes } from '../../utils/enums';
import { formatThousands } from '../../utils/fillDynamicText';
import { copyFor } from '../../copy/copy';

const TitleComponent = props => (
    <Title>
        {props.enableAltEndCardSharing && props.useLocalRepresentative?
            (<Span>{copyFor('feedback', 'altShareTitle', 'petition',undefined,{partnerName:props.partnerName})}</Span>)
            :props.useLocalRepresentative ? (
            <Span>
                {copyFor('feedback', 'sent', 'petition', undefined, {
                    recipientName: 'Rep ' + props.repFullName
                })}
            </Span>
            ) : (
            <Span>{copyFor('feedback', 'signed', 'petition')}</Span>
        )}
    </Title>
);

TitleComponent.propTypes = {
    useLocalRepresentative: PropTypes.bool,
    repFullName: PropTypes.string,
    partnerName:PropTypes.string,
    enableAltEndCardSharing:PropTypes.bool,
};

const altShareDefaultTwitterFacebookMessage = partnerName =>
    copyFor('feedback','altShareTwitterFacebookMessage', 'petition',undefined,{partnerName})

const PetitionAction = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            rightAlign
            thankYouText={props.thankYouText}
            thankYouTitle={props.thankYouTitle}
            peopleCount={props.peopleCount}
            useLocalRepresentative={props.useLocalRepresentative}
            altShareDefaultTwitterFacebookMessage={altShareDefaultTwitterFacebookMessage(props.partnerName)}
            titleComponent={
                <TitleComponent
                    useLocalRepresentative={props.useLocalRepresentative}
                    repFullName={props.repFullName}
                    partnerName={props.partnerName}
                    enableAltEndCardSharing={props.enableAltEndCardSharing}
                />
            }
            beforeAdvancing={() => {
                props.setExitingCardProps('petition', props, props.exitingAction);
            }}
            {...props}
        />
    </TransitionContainerNoExit>
);

PetitionAction.propTypes = {
    exitingAction: PropTypes.object.isRequired,
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string,
    peopleCount: PropTypes.string.isRequired,
    useLocalRepresentative: PropTypes.bool,
    repFullName: PropTypes.string,
    setExitingCardProps: PropTypes.func.isRequired,
    partnerName:PropTypes.string,
    enableAltEndCardSharing:PropTypes.bool,
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'petition',
            ['/petition/success'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            exitingAction: state.widget.activeAction,
            repFullName: state.localRep.localRepData.representative
                ? state.localRep.localRepData.representative[0].fullName
                : '',
            thankYouText: state.widget.activeAction.thankYouText || '',
            thankYouTitle: state.widget.activeAction.thankYouTitle || '',
            peopleCount:
                state.petition.completePetition !== undefined
                    ? formatThousands(state.petition.completePetition.endUsersCount)
                    : '',
            useLocalRepresentative: !!state.widget.activeAction.representativeSearch,
            partnerName: state.widget.activeAction.partner? state.widget.activeAction.partner.name:'Speakable',
            enableAltEndCardSharing: state.widget.activeAction.enableAltEndCardSharing,
        };
    },
    { setExitingCardProps },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Petition) return true;
            return next === prev;
        }
    }
)(PetitionAction);
